import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-drop-fill text-lg"></i>
              </div>
              <span className="text-lg font-semibold whitespace-nowrap">{siteInfo.name}</span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed">
              科学认知，安全挑战，健康第一。为憋尿任务参与者提供全面的知识指导。
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider opacity-80">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/rules" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">挑战规则</Link>
              <Link to="/category/precautions" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">注意事项</Link>
              <Link to="/category/health-risks" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">健康风险</Link>
              <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider opacity-80">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/scenarios" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">场景设定</Link>
              <Link to="/category/techniques" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">挑战技巧</Link>
              <Link to="/category/bladder-health" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">膀胱健康</Link>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider opacity-80">免责声明</h4>
            <p className="text-xs text-background-50/60 leading-relaxed">
              本站所有内容仅供参考，不构成医疗建议。憋尿挑战存在健康风险，请在充分了解风险并咨询专业医师后自行决定是否参与。本站不对因使用本站信息而产生的任何后果承担责任。
            </p>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap" rel="nofollow">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}